export const environment = {
  production: false,
  googleAnalyticsId: 'G-68PTF7M4QG',
  services: {
    identity: 'https://api.stage.ticket-bangla.com',
    events: 'https://api.stage.ticket-bangla.com',
    admin: 'https://api.stage.ticket-bangla.com',
    bookings: 'https://api.stage.ticket-bangla.com',
    booking: 'https://api.stage.ticket-bangla.com',
    tickets: 'https://api.stage.ticket-bangla.com',
    ticketing: 'https://api.stage.ticket-bangla.com',
    userissue: 'https://api.stage.ticket-bangla.com',
    userissuehub: 'wss://chat.stage.ticket-bangla.com'
  },
  baseUrl: 'https://admin.stage.ticket-bangla.com',
  headerkey: '4HyD6HQpZ09grqbP7tRuLRQi0zIF7lYBAT',
  aws: {
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_sSgueR2CZ',
    userPoolWebClientId: '3eo3pg0f2jau121bqku7od9u4h',
  },
  homePageSettings: {
    homeTotalEvents: 8,
    fourImage: 4,
    eventContentImage: 'assets/icons/homepage/event-content-image.png',
  },
  serverless: {
    baseUrl: 'https://auth.stage.ticket-bangla.com',
    authorization: '4HyD6HQpZ09grqbP7tRuLRQi0zIF7lYBAT'
  },
  cloudFront: {
    cloudFrontUrl: 'https://download.admin.stage.ticket-bangla.com',
    mainDomain: 'ticket-bangla.com'
  }
};
